import { IRoute } from "@/routes/types";
import Login from "@/pages/Login";
import ParticipantsTestResults from "@/pages/ParticipantsTestResults";
import SecurityAwareness from "@/pages/SecurityAwareness";

export const pages = {
  login: "login",
  securityAwareness: "security-awareness",
  participantTestResults: "participant-test-results",
};

export const authRoutesList: Array<IRoute> = [
  { path: "login", component: Login },
];

export const routesList: Array<IRoute> = [
  { path: "security-awareness", component: SecurityAwareness },
  { path: "participant-test-results", component: ParticipantsTestResults },
];
